export const TOUR_HOME = 'tour-home'
export const ALL_TOURS = [TOUR_HOME]

export const tourHomeSteps = [
  {
    content: 'Benvenuto su Gestione posizioni prodotti',
  },
]
